<template>
    <div>
        <b-list-group class="col-md-12 mt-3 ml-3 mb-2" >
            <b-list-group-item class="justify-content-between align-items-center">
            <div class="row">
                <div class="col-md-9 col-sm-9">
                <b>{{extensible.heading}}</b><br>
                <span class="badge badge-success badge-pill mr-2"><i class="fa fa-question"> {{extensible.items.length}}question{{extensible.items.length == 1 ? '':'s'}}</i></span>
                </div>
                <div class="col-md-3 col-sm-3">
                  <div class="btn-group pull-right">
                    <b-dropdown class="btn-group" variant="p-0" right no-caret>
                      <template slot="button-content">
                        <i class="icon-options-vertical icons font-1xl"></i>
                      </template>
                      <b-dropdown-item title="Send as SMS" v-b-tooltip.hover @click="handleSendAsSMS()"><i class="icon-paper-plane icons font-1xl"></i>Send as SMS</b-dropdown-item>
                      <b-dropdown-item title="Reload" v-b-tooltip.hover @click="handleReload()"><i class="icon-refresh icons font-1xl"></i>Reload</b-dropdown-item>
                      <b-dropdown-item v-if="isMobileDevice" title="Share" @click="handleShare()"><i class="icon-share icons font-1xl"></i>Share</b-dropdown-item>
                      <b-dropdown-item title="Delete" @click="handleMessageDelete()"><i class="icon-trash icons font-1xl"></i>Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
            </div>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start">
              <b-list-group>
                <b-list-group-item class="flex-column align-items-start"
                    v-for="(question, index) in extensible.items"
                    :key="index"
                >
                    <div class="w-100">
                      <h5 class="mb-3 d-inline">{{`${index+1}. ${question.item}`}}</h5>
                      <span class="pull-right"><b>{{itemTotalResponse(question.options)}}</b></span>
                      <hr>
                    </div>
                    <b-form-group class="ml-3">
                        <b-form-checkbox-group disabled stacked id="basicCheckboxes" name="Checkboxes">
                          <div v-for="(answer, i) in question.options" 
                              :key="i" class="mb-3">
                            <b-form-checkbox class="d-inline">{{answer.option}}</b-form-checkbox>
                            <span class="pull-right">{{answer.total}}</span>
                            <b-progress height="2px" :value="answerPercentage(answer.total, itemTotalResponse(question.options))"></b-progress>
                          </div>
                        </b-form-checkbox-group>
                    </b-form-group>
                </b-list-group-item>
              </b-list-group>
            <span class="text-muted"><small><i class="icon-calendar icons font-1xl"> {{extensible.created_date}}</i></small></span>
            <br>
            <span class="text-muted"><small>
            <i class="icon-clock icons font-1xl"> {{extensible.created_time}}</i></small></span>
            <div class="pt-2"></div>
            <template v-if="extensible.subcode != '' && extensible.subcode != null">
              <span class="badge badge-primary badge-pill mr-2"><i class='fa fa-rss'></i> {{getNewsletterNameBySubcode}}</span> 
            </template>
            <span class="badge badge-secondary badge-pill mr-2"><i :class="(extensible.is_private)?'fa fa-lock':'fa fa-unlock'" ></i> {{extensible.is_private ? 'Private' : 'Public'}} Audience</span>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start">
              <a :href="url+extensible.slug" target="_blank">{{url+extensible.slug}}</a>
                <!-- Right aligned nav items -->
                <b-button v-b-tooltip.hover title="Copy" class="pull-right" variant="success"
                            v-clipboard:copy="url+extensible.slug"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onCopyError">Copy</b-button>
            </b-list-group-item>
            <b-list-group-item class="flex-column align-items-start">
                <span>{{extensible.message}}</span>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { isMobileDevice } from '@/shared/utils'

import { Plugins } from '@capacitor/core'
const { Share } = Plugins

export default {
  name: 'QuestionnaireView',
  components: {
    VuePerfectScrollbar,
  },
  data () {
    return {
      url: process.env.VUE_APP_EXT_BASE_URL,
      itemTotal: 0,
      Share: Share,
      isMobileDevice: false,
    }
  },
  props: {
    extensible: {
      type: Object,
      default: null
    },
    type: String,
  },
  notifications: {
    onCopyError: {
      title: 'Failed',
      message: 'There was error copying the content',
      type: 'error'
    },
    onCopy: {
      title: 'Success',
      message: 'Content copied',
      type: 'success'
    },
    responseError: {
      title: 'Failed',
      message: 'An error occurred, kindly try again later.',
      type: 'error'
    },
    responseSuccess: {
      title: 'Success',
      message: 'Deleted successfully.',
      type: 'success'
    }
  },
  computed: {
    ...mapState('newsletter', ['newsletters']),
    ...mapState('user', ['user']),

    getNewsletterNameBySubcode: function () {
        let name = ''
        let self = this
        this.newsletters.forEach(function (newsletter, key) {
            if (self.extensible.subcode === newsletter.subcode) {
                name = newsletter.name
            }
        })
        return name
    }
  },
  created: async function(){
    this.isMobileDevice = await isMobileDevice()
  },
  methods: {
    ...mapActions('extensibleSms', ['delete', 'reloadQuestionnaire']),
    itemTotalResponse: function(options) {
      let total = 0
      for (let index = 0; index < options.length; index++) {
        total += options[index].total
      }
      this.itemTotal = total

      return total
    },
    answerPercentage: function(total, grandTotal) {
      return ((total/grandTotal)*100).toFixed(2)
    },
    handleSendAsSMS: function() {
      this.$emit('template-send-as-sms', `${this.extensible.heading}\n${this.url}${this.extensible.slug}`)
    },
    handleMessageDelete: async function() {
      if(!confirm('Sure you want to delete this?'))
        return

      let status = await this.delete({data: {id: this.extensible.id, 
                                              type: 'questionnaire', 
                                              uuid: this.user.uuid, 
                                              qType: this.extensible.type_id
                                              }
                                          })
      if (status) {
        this.responseSuccess()
        this.$emit(`deleted-extensible`)
      } else {
        this.responseError()
      }
    },
    handleReload: async function() {
      let response = await this.reloadQuestionnaire({data: {id: this.extensible.id, 
                                              uuid: this.user.uuid, 
                                              qType: this.extensible.type_id
                                              }
                                          })
      if (response != null) {
        this.$emit('reloaded-questionnaire', response)
      }
    },
    handleShare: async function() {
      let shareRet = await Share.share({
        title: this.extensible.heading,
        text: `${this.extensible.heading}`,
        url: `${this.url}${this.extensible.slug}`,
        dialogTitle: 'Share with buddies',
      })
    }
  }
}
</script>